var _circle, _circle2, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSpIOr(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 16,
    viewBox: "0 0 25 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 7.5,
    fill: "#9DB5C4",
    fillOpacity: 0.5,
    stroke: "#9DB5C4"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 17,
    cy: 8,
    r: 7.5,
    fill: "#9DB5C4",
    fillOpacity: 0.5,
    stroke: "#9DB5C4"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.0156 7.99219C10.0156 3.71094 12.5 2.64062 12.5 2.64062C12.5 2.64062 14.9844 3.71094 14.9844 7.99219C14.9844 12.2734 12.5 13.3438 12.5 13.3438C12.5 13.3438 10.0156 12.2734 10.0156 7.99219Z",
    fill: "#C1D0D8"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSpIOr);
export default __webpack_public_path__ + "static/media/sp-i-or.d9c713a3185d6053cdec047e4cdeef7a.svg";
export { ForwardRef as ReactComponent };